import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-date-renderer",
  template: `
    <span class="grid-date-cell">
      {{ dateToShow | date: "dd-MMM | h:mm a" }}
    </span>
  `,
  styles: [],
})
export class DateRendererComponent implements OnInit {
  @Input() dateValue: string;
  dateToShow: Date;

  ngOnInit() {
    this.dateToShow = new Date(this.dateValue);
  }
}
